<template>
  <div align="center" class="book-page-wrap">
    <div class="container">
      <div class="book-page-content">
        <div class="image-wrap">
          <img
            src="../assets/smilenoview.png"
            alt=""
            class="shani-img"
            align="left"
          />
        </div>
        <div class="content-wrap">
          <h2>
            Achieving success and happiness is closer than you think. The tools
            and techniques for your transformation are finally here! Are you
            ready for a life-changing opportunity?
          </h2>
          <div class="order-btn-wrap">
            <img
              src="../assets/frontcovershani.jpg"
              alt=""
              class="book-cover"
            />
            <!-- <p class="description">Available both on paperback and ebook</p> -->
            <a href="https://amzn.to/3kksCRB" target="_blank">
              <button class="button btn-filled-black book-order-btn">
                Yes! I am ready
                <span style="display: inline-flex"
                  ><img src="../assets/right-arrow.svg" alt=""
                /></span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookPage",
};
</script>

<style lang="scss" scoped>
.book-page-wrap {
  margin: 7rem 0 4rem 0;
}
.book-page-content {
  display: flex;

  .shani-img {
    display: none;
  }

  .image-wrap {
    display: flex;
    // align-items: flex-end;
  }
}

.content-wrap {
  padding: 30px;
  border-top: 10px solid #ffa9be;
  border-right: 1px solid #ffa9be;
  border-bottom: 1px solid #ffa9be;
  // font-family: Raleway;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h2 {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: 20px;
    // text-transform: uppercase;
  }
}
.order-btn-wrap {
  position: relative;

  .description {
    margin-top: 16px;
  }
}

.book-cover {
  width: 100px;
  height: auto;
  z-index: 999;
  border-bottom: 1px solid #ccc;
  display: block;
  margin-bottom: 25px;
}

.book-order-btn {
  padding: 16px 20px;
}

@media screen and (min-width: 481px) {
  .content-wrap {
    padding: 30px 50px;
    h2 {
      font-size: 24px;
      text-align: start;
    }
  }
}

@media screen and (min-width: 768px) {
  .book-page-wrap {
    margin: 7rem 0;
  }
  .content-wrap {
    padding: 60px 80px;
  }
  .book-cover {
    position: absolute;
    left: 100px;
    top: -65%;
    transform: rotate(-15deg);
    margin-bottom: 0;
  }

  .order-btn-wrap {
    margin: 40px 0;

    .description {
      margin-left: 40px;
      margin-top: 0;
      max-width: 35%;
      text-align: left;
    }
  }
  .book-order-btn {
    padding: 16px 20px 16px 45px;
  }
}

@media screen and (min-width: 992px) {
  .content-wrap {
    padding: 60px 40px;
  }
  .order-btn-wrap .description {
    margin-left: 95px;
    max-width: 45%;
  }
  .book-page-content {
    display: grid;
    // gap: 20px;
    grid-template-columns: 1fr 1.5fr;

    .shani-img {
      display: block;
      max-width: 100%;
      // height: 100%;
      object-fit: cover;
    }
  }
  .book-cover {
    left: 75px;
  }
  .book-order-btn {
    padding: 16px 20px 16px 50px;
  }
}

@media screen and (min-width: 1200px) {
  .book-page-wrap {
    margin-top: 3rem;
  }
  .content-wrap {
    padding: 60px 80px;
  }
}
</style>
